/* Free shipping progress bar — Lash Atelier
   Thresholds (CAD): Canada & US $150, everywhere else $275.
   Converted to the visitor's currency with Shopify.currency.rate. */
(function () {
  if (window.__laFreeShipBar) return;
  window.__laFreeShipBar = true;

  var S = window.Shopify || {};
  var country = (S.country || 'CA').toUpperCase();
  var thresholdCad = country === 'CA' || country === 'US' ? 150 : 275;
  var rate = (S.currency && parseFloat(S.currency.rate)) || 1;
  var currency = (S.currency && S.currency.active) || 'CAD';
  var lang = (S.locale || document.documentElement.lang || 'en').slice(0, 2);
  var fr = lang === 'fr';
  var thresholdCents = Math.ceil(thresholdCad * rate) * 100;

  var TXT = fr
    ? { away: ['Plus que ', ' pour la livraison express gratuite!'], done: 'Bravo! Votre commande est admissible à la livraison express gratuite.' }
    : { away: ["You're ", ' away from free express shipping!'], done: "You've unlocked free express shipping!" };

  var css =
    '.la-fsb{display:block;margin:1rem 0 1.6rem;padding:1.2rem 1.4rem;border-radius:.8rem;' +
    'background:rgba(var(--color-foreground),.04);border:1px solid rgba(var(--color-foreground),.08)}' +
    '.la-fsb__text{margin:0 0 .8rem;font-size:1.4rem;line-height:1.4;text-align:center}' +
    '.la-fsb__track{height:.6rem;border-radius:99px;overflow:hidden;background:rgba(var(--color-foreground),.12)}' +
    '.la-fsb__fill{height:100%;border-radius:99px;background:rgb(var(--color-foreground));transition:width .4s ease}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var lastTotal = null;

  function fmt(cents) {
    try {
      return new Intl.NumberFormat(lang + '-' + country, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function build(total) {
    var el = document.createElement('div');
    el.className = 'la-fsb';
    var p = document.createElement('p');
    p.className = 'la-fsb__text';
    var remaining = thresholdCents - total;
    if (remaining <= 0) {
      p.textContent = TXT.done;
    } else {
      p.appendChild(document.createTextNode(TXT.away[0]));
      var b = document.createElement('strong');
      b.textContent = fmt(remaining);
      p.appendChild(b);
      p.appendChild(document.createTextNode(TXT.away[1]));
    }
    var track = document.createElement('div');
    track.className = 'la-fsb__track';
    track.setAttribute('aria-hidden', 'true');
    var fill = document.createElement('div');
    fill.className = 'la-fsb__fill';
    fill.style.width = Math.min(100, (total / thresholdCents) * 100) + '%';
    track.appendChild(fill);
    el.appendChild(p);
    el.appendChild(track);
    return el;
  }

  function targets() {
    return document.querySelectorAll('#CartDrawer-CartItems, #main-cart-items .js-contents');
  }

  function paint(total) {
    targets().forEach(function (t) {
      var old = t.querySelector(':scope > .la-fsb');
      if (old) old.remove();
      if (total > 0) t.insertBefore(build(total), t.firstChild);
    });
  }

  var pending = null;
  function refresh() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      fetch((window.routes && routes.cart_url ? routes.cart_url : '/cart') + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { lastTotal = cart.total_price; paint(lastTotal); })
        .catch(function () {});
    }, 150);
  }

  function ensure() {
    // Re-add after the theme swaps cart HTML, without refetching if we already know the total.
    targets().forEach(function (t) {
      if (!t.querySelector(':scope > .la-fsb') && lastTotal !== null) paint(lastTotal);
    });
  }

  function init() {
    refresh();
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    }
    document.addEventListener('cart:updated', refresh);
    var ours = function (n) { return n.nodeType === 1 && (n.classList.contains('la-fsb') || n.closest('.la-fsb')); };
    var mo = new MutationObserver(function (list) {
      var external = list.some(function (m) {
        if (m.target.nodeType === 1 && m.target.closest('.la-fsb')) return false;
        var nodes = Array.prototype.slice.call(m.addedNodes).concat(Array.prototype.slice.call(m.removedNodes));
        return nodes.some(function (n) { return !ours(n) && !(n.nodeType === 3 && !n.textContent.trim()); });
      });
      if (!external) return;
      ensure();
      refresh();
    });
    ['cart-drawer', 'cart-items', 'cart-drawer-items'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (n) { mo.observe(n, { childList: true, subtree: false }); });
    });
    var inner = document.querySelectorAll('.drawer__inner, #main-cart-items');
    inner.forEach(function (n) { mo.observe(n, { childList: true, subtree: true }); });
  }

  if (document.readyState === 'complete') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
